import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { useAuth } from '../contexts/AuthContext';

const Documentation: React.FC = () => {
  const { user } = useAuth();
  const [markdownContent, setMarkdownContent] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadMarkdown = async () => {
      try {
        setLoading(true);
        console.log('Loading documentation from /BENUTZERDOKUMENTATION.md');
        const response = await fetch('/BENUTZERDOKUMENTATION.md');
        console.log('Response status:', response.status);
        if (!response.ok) {
          throw new Error(`Dokumentation konnte nicht geladen werden (Status: ${response.status})`);
        }
        const content = await response.text();
        console.log('Content loaded, length:', content.length);
        setMarkdownContent(content);
        setError(null);
      } catch (err) {
        console.error('Error loading documentation:', err);
        setError(`Die Dokumentation konnte nicht geladen werden: ${err instanceof Error ? err.message : 'Unbekannter Fehler'}`);
      } finally {
        setLoading(false);
      }
    };

    loadMarkdown();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center">
        <div className="bg-white rounded-xl shadow-lg p-8 max-w-md w-full mx-4">
          <div className="flex items-center justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600"></div>
          </div>
          <p className="text-center text-gray-600 mt-4">Dokumentation wird geladen...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center">
        <div className="bg-white rounded-xl shadow-lg p-8 max-w-md w-full mx-4">
          <div className="text-center">
            <div className="text-red-500 text-6xl mb-4">⚠️</div>
            <h2 className="text-xl font-bold text-gray-900 mb-2">Fehler beim Laden</h2>
            <p className="text-gray-600">{error}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Combined Card */}
        <div style={{
          backgroundColor: 'white',
          borderRadius: '16px',
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
          border: '1px solid #e5e7eb',
          overflow: 'hidden',
          marginBottom: '32px'
        }}>
          {/* Roter Header */}
          <div style={{
            backgroundColor: '#c91f0c',
            padding: '40px 32px',
            position: 'relative'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}>
              <div>
                <h1 style={{
                  fontSize: '36px',
                  fontWeight: 'bold',
                  color: 'white',
                  margin: '0 0 12px 0',
                  textShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                }}>Benutzerdokumentation</h1>
              </div>
              <div style={{
                display: window.innerWidth > 768 ? 'block' : 'none'
              }}>
              </div>
            </div>
          </div>
          
          <div style={{
            padding: '32px'
          }}>
            <div style={{
              marginBottom: '24px'
            }}>
              <p style={{
                fontSize: '16px',
                color: '#6b7280',
                margin: 0
              }}>Hallo <span style={{ fontWeight: '600', color: '#111827' }}>{user?.firstname}</span>!</p>
            </div>
            <div style={{
              lineHeight: '1.6',
              fontSize: '16px',
              color: '#374151',
              maxWidth: '100%'
            }}>
              <ReactMarkdown 
                remarkPlugins={[remarkGfm]}
                components={{
                  a: ({node, ...props}) => (
                    <a 
                      {...props} 
                      style={{
                        color: '#c91f0c',
                        fontWeight: 'bold',
                        textDecoration: 'none'
                      }}
                    />
                  )
                }}
              >
                {markdownContent}
              </ReactMarkdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Documentation;
